import { render, staticRenderFns } from "./SettingsOptions.vue?vue&type=template&id=400215fb"
import script from "./SettingsOptions.vue?vue&type=script&lang=ts"
export * from "./SettingsOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports